import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Popover,
  Snackbar,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  Backdrop,
  CircularProgress,
  Theme,
  createStyles,
  Box
} from '@material-ui/core';
import { MoreVert, Menu } from '@material-ui/icons';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import CloudOutlinedIcon from '@material-ui/icons/CloudOutlined';
import QueueOutlinedIcon from '@material-ui/icons/QueueOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import FilterIcon from '@material-ui/icons/Filter';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

import logo from '../../../assets/logo.png';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Redirect, useHistory } from 'react-router-dom';
import {
  btnColor,
  userRole,
  isLoggedIn,
  userIdState,
  userNameState,
  tenantNameState,
  tenantTaxRuleState,
  mainBlueColor,
  userPlanId,
  userMenuId,
  userSiteManagePlanId,
  progressFlgState,
  progressCountState,
  progressCountFlgState,
  versionState,
  userTenant,
  isEContractServiceEnabledState
} from '../../../GlobalState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { logout } from '../../../apicalls/logout';
import {
  getUserPermission,
  getUserTenant
} from '../../../apicalls/employeeMaster';
import { getCurrentVersion } from '../../../apicalls/version';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import OperationManual from '../../../assets/operation_manual.svg';
import { ModalDashboard } from '../../ModalDashboard';
import { TopicPath } from '../../topicPath/TopicPath';
import { AuthInfoContext } from '../../../AuthContextProvider';
import { faqLink, SITE_MANGE_PLAN_ACCESS_ALLOW } from '../../../const/Const';
import { TTopicPathState } from '../../topicPath/type/Type';
import { log } from '../../../utils';
import { TTenant } from '../../../types/common';
import MenuTreeComponent from './MenuTreeCompoent';

type Anchor = 'left';

interface TProps {
  patternName?: string;
  isSharePage?: boolean;
  patternState?: TTopicPathState;
  isDocumentDownloadPage?: boolean;
}

const AppBarComponent: React.FC<TProps> = ({
  patternName,
  isSharePage,
  patternState,
  isDocumentDownloadPage
}) => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [userPermission, setUserPermission] = useRecoilState<any>(userRole);
  const [userId, setUserId] = useRecoilState<number>(userIdState);
  const [userName, setUserName] = useRecoilState<string>(userNameState);
  const [tenantName, setTenantName] = useRecoilState<string>(tenantNameState);
  const [tenantTaxRule, setTenantTaxRule] =
    useRecoilState<number>(tenantTaxRuleState);
  const [version, setVersion] = useRecoilState<string>(versionState);
  const [progressFlg] = useRecoilState<boolean>(progressFlgState);
  const [progressCountFlg] = useRecoilState<boolean>(progressCountFlgState);
  const [progressCount] = useRecoilState<number>(progressCountState);
  const setLoggedIn = useSetRecoilState(isLoggedIn);
  const [isEContractServiceEnabled, setIsEContractServiceEnabled] =
    useRecoilState<any>(isEContractServiceEnabledState);

  const [userPlan, setUserPlan] = useRecoilState<any>(userPlanId);
  const [userMenu, setUserMenu] = useRecoilState<any>(userMenuId);

  const [userSiteManagePlan, setUserSiteMangePlan] =
    useRecoilState<any>(userSiteManagePlanId);
  const [, setUserTenantData] = useRecoilState<TTenant | undefined>(userTenant);

  const matches2 = useMediaQuery('(min-width:900px)');

  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const history = useHistory();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      list: {
        width: 320
      },
      listWrapper: {
        paddingTop: 0,
        paddingBottom: 100
      },
      paper: {
        background: buttonColor,
        marginTop: 64
      },
      typography: {
        padding: 10
      },
      backdrop: {
        zIndex: 10000,
        color: '#fff'
      },
      listTitle: {
        backgroundColor: '#333333',
        pointerEvents: 'none'
      },
      listTitleText: {
        color: '#FFFFFF'
      },
      listItemText: {
        color: '#FFFFFF',
        paddingLeft: 36
      }
    })
  );

  const StyledListItem = withStyles(theme => ({
    root: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }))(ListItem);

  const logoutFunction = useCallback(
    (browserClose: boolean) => {
      logout().then(data => {
        if (data === 'Not logged in!') {
          // changeLoggedInData("Not logged in!")
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpenError(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpenError(true);
            } else {
              if (browserClose === false) {
                if (data.msg === 'Successfully logout') {
                  if (
                    window.location.pathname.includes('/sharefile') ||
                    window.location.pathname.includes('/sharepicture')
                  ) {
                    // 共有ゲストがログアウトした場合はLPを表示
                    window.location.assign('https://storage-lp.conoc.jp/');
                  } else {
                    history.push('/');
                  }
                }
              }
            }
          }
        }
      });
    },
    [history]
  );

  const classes = useStyles();
  const [state, setState] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setState(open);
    };

  /**
   * TODO
   * AccessibleMenuComponentの動作に問題がなければ削除
   */
  // const list = () => (
  //   <div
  //     className={classes.list}
  //     role="presentation"
  //     onClick={toggleDrawer(false)}
  //     onKeyDown={toggleDrawer(false)}
  //   >
  //     <List className={classes.listWrapper}>
  //       <>
  //         {((userMenu !== "Storage" && userPlan !== 3) &&
  //           (userPermission === 1 ||
  //             userPermission === 2 ||
  //             userPermission === null
  //             )) && (
  //           <StyledListItem
  //             button
  //             className={classes.listTitle}
  //           >
  //             <ListItemIcon style={{ minWidth: 36 }}>
  //               <AssessmentOutlinedIcon style={{ color: "fff" }} />
  //             </ListItemIcon>
  //             <ListItemText className={classes.listTitleText} primary={"ダッシュボード"} />
  //           </StyledListItem>
  //         )}

  //         {/* ダッシュボード */}
  //         {((userMenu != "Storage" && userPlan !== 3) &&
  //           (userPermission === 1 ||
  //             userPermission === 2 ||
  //             userPermission === null)) && (
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (userPlan === 3) {
  //                   handleClickOpenAlert();
  //                 } else {
  //                   if (userPlan !== undefined) {
  //                     if (history.location.pathname !== "/dashboard") {
  //                       log.info("to dashboard");
  //                       history.push("/dashboard");
  //                     }
  //                   }
  //                 }
  //               }}
  //             >
  //               <ListItemText
  //                 className={classes.listItemText}
  //                 primary={"ダッシュボード"}
  //               />
  //             </StyledListItem>
  //           )}

  //         {/* 目標設定 */}
  //         {((userMenu != "Storage" && userPlan !== 3) &&
  //           (userPermission === 1 ||
  //             userPermission === null)) && (
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (history.location.pathname !== "/sales/setting") {
  //                   history.push("/sales/setting");
  //                 }
  //               }}
  //             >
  //               <ListItemText className={classes.listItemText} primary={"目標設定"} />
  //             </StyledListItem>
  //           )}

  //         <StyledListItem
  //           button
  //           className={classes.listTitle}
  //         >
  //           <ListItemIcon style={{ minWidth: 36 }}>
  //             <FolderOutlinedIcon style={{ color: "fff" }} />
  //           </ListItemIcon>
  //           <ListItemText className={classes.listTitleText} primary={"情報管理"} />
  //         </StyledListItem>

  //         {/* 顧客 */}
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             if (history.location.pathname !== "/customers") {
  //               history.push("/customers");
  //             }
  //           }}
  //         >
  //           <ListItemText className={classes.listItemText} primary={"顧客"} />
  //         </StyledListItem>

  //         {/* 業者 */}
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             if (history.location.pathname !== "/vendors") {
  //               history.push("/vendors");
  //             }
  //           }}
  //         >
  //           <ListItemText className={classes.listItemText} primary={"業者"} />
  //         </StyledListItem>

  //         {/* 工事 */}
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             if (history.location.pathname !== "/constructions") {
  //               history.push("/constructions");
  //             }
  //           }}
  //         >
  //           <ListItemText className={classes.listItemText} primary={"工事"} />
  //         </StyledListItem>
  //         {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
  //         {userSiteManagePlan != 99 && (
  //           <>
  //             <StyledListItem button className={classes.listTitle}>
  //               <ListItemIcon style={{ minWidth: 36 }}>
  //                 <FilterIcon style={{ color: 'fff' }} />
  //               </ListItemIcon>
  //               <ListItemText
  //                 className={classes.listTitleText}
  //                 primary={'現場管理'}
  //               />
  //             </StyledListItem>
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (history.location.pathname !== '/daily-reports') {
  //                   history.push('/daily-reports');
  //                 }
  //               }}
  //             >
  //               <ListItemText
  //                 className={classes.listItemText}
  //                 primary={'日報'}
  //               />
  //             </StyledListItem>
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (history.location.pathname !== '/processes') {
  //                   history.push('/processes');
  //                 }
  //               }}
  //             >
  //               <ListItemText
  //                 className={classes.listItemText}
  //                 primary={'工程'}
  //               />
  //             </StyledListItem>
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (history.location.pathname !== '/calendar') {
  //                   history.push('/calendar');
  //                 }
  //               }}
  //             >
  //               <ListItemText
  //                 className={classes.listItemText}
  //                 primary={'カレンダー'}
  //               />
  //             </StyledListItem>
  //           </>
  //         )}

  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             className={classes.listTitle}
  //           >
  //             <ListItemIcon style={{ minWidth: 36 }}>
  //               <QueueOutlinedIcon style={{ color: "fff" }} />
  //             </ListItemIcon>
  //             <ListItemText className={classes.listTitleText} primary={"ツール"} />
  //           </StyledListItem>
  //         )}

  //         {/* 書類作成 */}
  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/estimates") {
  //                 history.push("/estimates");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"書類"} />
  //           </StyledListItem>
  //         )}

  //         {/* PDFダウンロード */}
  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/pdf") {
  //                 history.push("/pdf");
  //               }
  //             }}
  //           >
  //             <ListItemText
  //               className={classes.listItemText}
  //               primary={"PDFダウンロード"}
  //             />
  //           </StyledListItem>
  //         )}

  //         {/* 書類送信履歴 */}
  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/document-transmission") {
  //                 history.push("/document-transmission");
  //               }
  //             }}
  //           >
  //             <ListItemText
  //               className={classes.listItemText}
  //               primary={"メール送信履歴"}
  //             />
  //           </StyledListItem>
  //         )}

  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             className={classes.listTitle}
  //           >
  //             <ListItemIcon style={{ minWidth: 36 }}>
  //               <CloudOutlinedIcon style={{ color: "fff" }} />
  //             </ListItemIcon>
  //             <ListItemText className={classes.listTitleText} primary={"クラウドストレージ"} />
  //           </StyledListItem>
  //         )}

  //         {/* 資料 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/files") {
  //                 history.push("/files");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"資料"} />
  //           </StyledListItem>
  //         )}

  //         {/* 写真 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/pictures") {
  //                 history.push("/pictures");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"写真"} />
  //           </StyledListItem>
  //         )}

  //         {/* 共有先 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/guest-manage") {
  //                 history.push("/guest-manage");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"共有先管理"} />
  //           </StyledListItem>
  //         )}

  //         {/* 操作履歴 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/filelog") {
  //                 history.push("/filelog");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"操作履歴"} />
  //           </StyledListItem>
  //         )}

  //         {/* 写真台帳 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/ledger-list") {
  //                 history.push("/ledger-list");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"写真台帳"} />
  //           </StyledListItem>
  //         )}

  //         <StyledListItem
  //           button
  //           className={classes.listTitle}
  //         >
  //           <ListItemIcon style={{ minWidth: 36 }}>
  //             <SettingsOutlinedIcon style={{ color: "fff" }} />
  //           </ListItemIcon>
  //           <ListItemText className={classes.listTitleText} primary={"各種設定"} />
  //         </StyledListItem>

  //         {/* 顧客種別マスタ */}
  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/customertypes") {
  //                 history.push("/customertypes");
  //               }
  //             }}
  //           >
  //             <ListItemText
  //               className={classes.listItemText}
  //               primary={"顧客種別マスタ"}
  //             />
  //           </StyledListItem>
  //         )}

  //         {/* 業種マスタ */}
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             if (history.location.pathname !== "/partner-categories") {
  //               history.push("/partner-categories");
  //             }
  //           }}
  //         >
  //           <ListItemText
  //             className={classes.listItemText}
  //             primary={"業種マスタ"}
  //           />
  //         </StyledListItem>

  //         {/* 見積書マスタ */}
  //         {(userMenu != "Storage") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/estimate-master") {
  //                 history.push("/estimate-master");
  //               }
  //             }}
  //           >
  //             <ListItemText
  //               className={classes.listItemText}
  //               primary={"見積書マスタ"}
  //             />
  //           </StyledListItem>
  //         )}

  //         {/* 資料種別 */}
  //         {(userMenu != "BM") && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/filetypes") {
  //                 history.push("/filetypes");
  //               }
  //             }}
  //           >
  //             <ListItemText className={classes.listItemText} primary={"資料種別"} />
  //           </StyledListItem>
  //         )}

  //         {/* 自社情報 */}
  //         {(userPermission === 1 || userPermission === null) && (
  //           <>
  //             <StyledListItem
  //               button
  //               onClick={() => {
  //                 if (history.location.pathname !== "/company-information") {
  //                   history.push("/company-information");
  //                 }
  //               }}
  //             >
  //               <ListItemText
  //                 className={classes.listItemText}
  //                 primary={"自社情報"}
  //               />
  //             </StyledListItem>
  //           </>
  //         )}

  //         {/* 社員 */}
  //         {(userPermission === 1 || userPermission === null) && (
  //           <StyledListItem
  //             button
  //             onClick={() => {
  //               if (history.location.pathname !== "/employee-masters") {
  //                 history.push("/employee-masters");
  //               }
  //             }}
  //           >
  //             <ListItemText
  //               className={classes.listItemText}
  //               primary={"社員"}
  //             />
  //           </StyledListItem>
  //         )}

  //         {/* 社員グループ */}
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             if (history.location.pathname !== "/employee-groups") {
  //               history.push("/employee-groups");
  //             }
  //           }}
  //         >
  //           <ListItemText
  //             className={classes.listItemText}
  //             primary={"社員グループ"}
  //           />
  //         </StyledListItem>

  //         <StyledListItem
  //           button
  //           className={classes.listTitle}
  //         >
  //           <ListItemIcon style={{ minWidth: 36 }}>
  //             <MoreHorizOutlinedIcon style={{ color: "fff" }} />
  //           </ListItemIcon>
  //           <ListItemText className={classes.listTitleText} primary={"その他"} />
  //         </StyledListItem>

  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             window.open(faqLink.terms_of_service, '_blank');
  //           }}
  //         >
  //           <ListItemText
  //             className={classes.listItemText}
  //             primary={"利用規約"}
  //           />
  //        </StyledListItem>
  //         <StyledListItem
  //           button
  //           onClick={() => {
  //             window.open(faqLink.release_note, '_blank');
  //           }}
  //         >
  //           <ListItemText
  //             className={classes.listItemText}
  //             primary={"リリースノート"}
  //           />
  //         </StyledListItem>
  //         {/* <Divider style={{ backgroundColor: "#758283" }} /> */}
  //       </>
  //     </List>
  //   </div>
  // );

  const handleCloseError = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  //認証情報
  const [, setAuthInfo] = useContext(AuthInfoContext);

  const getUserRole = useCallback(() => {
    getUserPermission().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
        setAuthInfo(undefined);
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpenError(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpenError(true);
          } else {
            setAuthInfo(data);
            setUserPermission(data.role);
            setUserId(data.user_id);
            setUserName(data.user_name);
            setTenantName(data.company_name);
            setTenantTaxRule(data.tax_rule);
            setUserPlan(data.plan_id);
            setUserMenu(data.menu);
            setUserSiteMangePlan(data.site_manage_plan_id);
            setIsEContractServiceEnabled(data.is_e_contract_service_enabled);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    setTenantName,
    setTenantTaxRule,
    setUserId,
    setUserName,
    setUserPermission,
    setUserPlan,
    setUserMenu
  ]);

  const getUserTenantData = useCallback(() => {
    getUserTenant().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
        setAuthInfo(undefined);
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpenError(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpenError(true);
          } else {
            setUserTenantData(data.data);
          }
        }
      }
    });
  }, [setUserTenantData]);

  /**
   * バージョン取得
   */
  const getVersion = () => {
    getCurrentVersion().then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpenError(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpenError(true);
          } else {
            if (version === '') {
              //バージョンが空
              //バージョンをStateにセット
              setVersion(data.data);
            } else {
              //バージョンを持っている
              if (version !== data.data) {
                //取得したバージョンに相違がある場合
                const newVersionStrings = data.data.split(':');
                const versionDate: string = newVersionStrings[0]; // ：の前の日付を取得
                const deleteFlg: string = newVersionStrings[1]; // ：の後の真偽値を取得

                //日付の記述が８桁であり、真偽値の記述があるかどうかをチェック
                if (
                  versionDate.length === 8 &&
                  (deleteFlg.includes('true') || deleteFlg.includes('false'))
                ) {
                  //末尾が「true」の場合はローカルストレージ削除
                  if (deleteFlg === 'true') {
                    localStorage.clear();
                  }
                  //リロードしStateを更新
                  window.location.reload();
                  setVersion(data.data);
                } else {
                  //バージョンのフォーマットが適切でなければ処理をしない
                  console.log('version format error');
                }
              }
            }
          }
        }
      }
    });
  };

  useEffect(() => {
    // 共有画面では都度画面を表示されるためバージョン処理は必要ないので除外
    if (!isDocumentDownloadPage) {
      if (
        !window.location.pathname.includes('/sharefile') &&
        !window.location.pathname.includes('/sharepicture')
      ) {
        getVersion();
      }
    }
  }, []);

  useEffect(() => {
    const alertUser = (e: any) => {
      e.preventDefault();
      e.returnValue = '';
      logoutFunction(true);
    };
    // 外部共有のページでは実行しない（ロール取得が不要 かつ エラーが表示されてしまうため）
    if (!(isSharePage || isDocumentDownloadPage)) {
      getUserRole();
      getUserTenantData();
    }
    window.addEventListener('unload', alertUser);
    return () => {
      window.removeEventListener('unload', alertUser);
    };
  }, [logoutFunction, getUserRole]);

  return (
    <>
      <Backdrop className={classes.backdrop} open={progressFlg}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <Backdrop className={classes.backdrop} open={progressCountFlg}>
        <Box position='relative' display='inline-flex'>
          <CircularProgress color='inherit' />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position='absolute'
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <Typography variant='caption' component='div'>{`${Math.round(
              progressCount
            )}%`}</Typography>
          </Box>
        </Box>
      </Backdrop>
      <AppBar style={{ backgroundColor: buttonColor }} position='sticky'>
        <Toolbar
          style={{
            justifyContent:
              isSharePage || isDocumentDownloadPage ? 'center' : 'space-between'
          }}
        >
          {/* 外部共有された側のページでは、左端のメニューは非表示 */}
          {!(isSharePage || isDocumentDownloadPage) && (
            <Menu onClick={toggleDrawer(true)} style={{ color: '#FFFFFF' }} />
          )}
          <img
            style={{ width: 100, height: 60, objectFit: 'contain' }}
            alt='logo'
            src={logo}
          />
          {!isDocumentDownloadPage && (
            <div>
              {matches2 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 18,
                    right: 70,
                    display: 'flex'
                  }}
                >
                  {isSharePage ? ( // 外部共有された側のページでは、操作マニュアルのみ表示
                    <>
                      <div
                        onClick={() => {
                          const url = faqLink.share_guest;
                          const win = window.open(url, '_blank');
                          if (win != null) {
                            win.focus();
                          }
                        }}
                        style={{
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          marginRight: 20
                        }}
                      >
                        操作マニュアル
                      </div>
                      <MoreVert
                        onClick={handleClick}
                        style={{ color: '#FFFFFF' }}
                      />
                    </>
                  ) : (
                    // 通常ページでは、会社名とユーザー名を表示
                    <>
                      <div style={{ fontWeight: 'bold', marginRight: 20 }}>
                        {tenantName}
                      </div>
                      <div style={{ fontWeight: 'bold' }}>{userName}</div>
                    </>
                  )}
                </div>
              )}
              {/* 外部共有された側のページでは、右端のメニューは非表示 */}
              {!(isSharePage || isDocumentDownloadPage) && (
                <MoreVert onClick={handleClick} style={{ color: '#FFFFFF' }} />
              )}
            </div>
          )}
        </Toolbar>
        {patternName && (
          <TopicPath
            patternName={patternName}
            setOpenError={setOpenError}
            setErrorMessage={setErrorMessage}
            patternState={patternState}
          />
        )}
      </AppBar>

      <Snackbar
        open={openError}
        autoHideDuration={4000}
        onClose={handleCloseError}
      >
        <Alert onClose={handleCloseError} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Dialog
        // maxWidth="md"
        maxWidth='lg'
        fullWidth={true}
        open={openAlert}
        onClose={handleCloseAlert}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title' style={{ marginTop: 10 }}>
          <div>
            {
              'ダッシュボードはスタンダードプランまたは、 エンタープライズプランでのみ 利用できる機能です。'
            }
          </div>
        </DialogTitle>
        <DialogContent>
          <ModalDashboard />
        </DialogContent>
        <DialogActions
          style={{ textAlign: 'left', justifyContent: 'flex-start' }}
        ></DialogActions>
        <DialogActions>
          <Button
            style={{ marginRight: 20, color: mainColor, fontWeight: 'bold' }}
            onClick={handleCloseAlert}
            color='primary'
            autoFocus
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>

      {/* メニューツリー表示 */}
      <MenuTreeComponent isOpen={state} setIsOpen={setState} />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        style={{ marginTop: 50, marginLeft: 15 }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <div style={{ width: 180 }}>
          {isSharePage ? ( //共有ゲスト画面
            <>
              <Typography className={classes.typography}>
                <div
                  onClick={() => {
                    logoutFunction(false);
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row'
                  }}
                >
                  {/* https://fonts.google.com/icons?selected=Material+Icons&icon.query=logout */}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    height='18px'
                    viewBox='0 0 24 24'
                    width='18px'
                    fill='#202020'
                  >
                    <path d='M0 0h24v24H0z' fill='none' />
                    <path d='M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z' />
                  </svg>
                  <div style={{ marginLeft: 10, marginRight: 40 }}>
                    ログアウト
                  </div>
                </div>
              </Typography>
            </>
          ) : (
            //conocユーザ画面
            <>
              <Typography className={classes.typography}>
                <div
                  onClick={() => {
                    const url = faqLink.top;
                    const win = window.open(url, '_blank');
                    if (win != null) {
                      win.focus();
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row'
                  }}
                >
                  <img
                    src={OperationManual}
                    style={{ height: 18 }}
                    alt='operation-manual'
                  />
                  <div style={{ marginLeft: 10 }}>操作マニュアル</div>
                </div>
              </Typography>

              <Typography className={classes.typography}>
                <div
                  onClick={() => {
                    history.push(`/change/password`);
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row'
                  }}
                >
                  <VpnKeyIcon style={{ color: '000', fontSize: 18 }} />
                  <div style={{ marginLeft: 10 }}>パスワード変更</div>
                </div>
              </Typography>

              <Typography className={classes.typography}>
                <div
                  onClick={() => {
                    logoutFunction(false);
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row'
                  }}
                >
                  {/* https://fonts.google.com/icons?selected=Material+Icons&icon.query=logout */}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    height='18px'
                    viewBox='0 0 24 24'
                    width='18px'
                    fill='#202020'
                  >
                    <path d='M0 0h24v24H0z' fill='none' />
                    <path d='M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z' />
                  </svg>
                  <div style={{ marginLeft: 10, marginRight: 40 }}>
                    ログアウト
                  </div>
                </div>
              </Typography>
            </>
          )}
        </div>
      </Popover>
    </>
  );
};
export default AppBarComponent;
